module.exports = __webpack_public_path__ + "static/media/file-add.6bfabb31.svg";